const Config = {
  'orderInvoice.detail.exchange': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '发票换开',
    c: {
      type: 'constant',
      value: 'reissue',
    },
    d: {
      type: 'constant',
      value: 1,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
          return 'invoice_status=' + traceData.invoiceStatus;
        }`,
    },
  },
  'orderInvoice.detail.sendemail': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '发送邮件',
    c: {
      type: 'constant',
      value: 'email',
    },
    d: {
      type: 'constant',
      value: 1,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
          return 'invoice_status=' + traceData.invoiceStatus;
        }`,
    },
  },
  'orderInvoice.detail.download': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '下载发票',
    c: {
      type: 'constant',
      value: 'download',
    },
    d: {
      type: 'constant',
      value: 1,
    },
    iid: {
      type: 'variable',
      func: `function getIid(traceData) {
          return 'invoice_status=' + traceData.invoiceStatus;
        }`,
    },
  },
};

export default Config;
